import script from "./fault-logs.vue?vue&type=script&lang=ts&setup=true"
export * from "./fault-logs.vue?vue&type=script&lang=ts&setup=true"

import "./fault-logs.vue?vue&type=style&index=0&id=ee17453e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee17453e"]])

export default __exports__